import { Button, Flex, VStack, Text } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";
import { APPC, UTIL } from "../config";

export type AppDateSelectSliderDataType = {
    date: Date;
    isDisabled?: boolean;
};

export interface AppDateSelectSliderProps {
    data: AppDateSelectSliderDataType[];
    selectedDate: Date;
    setSelectedDate: (date: Date) => void;
    start: Date;
    end: Date;
}

export const AppDateSelectSlider = ({
    data,
    selectedDate,
    setSelectedDate,
    start,
    end,
}: AppDateSelectSliderProps) => {
    const dayjs = UTIL.getDayJs();
    if (data.length < 1) {
        return <></>;
    }
    const handleSlide = (date: Date) => {
        let sd = date;
        if (date < start) {
            sd = start;
        }
        if (date > end) {
            sd = end;
        }
        setSelectedDate(sd);
    };
    return (
        <Flex
            width="full"
            alignItems={"center"}
            gap={4}
            overflowX={"auto"}
            wrap={"nowrap"}
        >
            <Button
                size={"md"}
                className={"btn-icon-md"}
                variant={"transparent"}
                onClick={() => {
                    handleSlide(
                        dayjs(data[0].date).subtract(7, "days").toDate()
                    );
                }}
                isDisabled={
                    dayjs(data[0].date).toDate() <= dayjs(start).toDate()
                }
            >
                <AppIcon
                    name={"icl-chevron-left-alt"}
                    w="1.5rem"
                    color={"var(--chakra-colors-primary)"}
                />
            </Button>
            <Flex
                flexGrow={1}
                gap={{ base: 3, xl: 3, "2xl": 6 }}
                p={2}
                justifyContent="flex-start"
            >
                {data.map((day, index) => (
                    <VStack
                        key={index}
                        width={"full"}
                        minW={"180px"}
                        maxW={"250px"}
                        bg={
                            dayjs(day.date).format(
                                APPC.APP_HTML_DATE_FORMAT
                            ) ===
                            dayjs(selectedDate).format(
                                APPC.APP_HTML_DATE_FORMAT
                            )
                                ? "var(--chakra-colors-primary)"
                                : day?.isDisabled
                                  ? "var(--chakra-colors-greyT95)"
                                  : "var(--chakra-colors-white)"
                        }
                        border={
                            day.isDisabled
                                ? ""
                                : "1px solid var(--chakra-colors-primaryT80)"
                        }
                        boxShadow={"md"}
                        borderRadius={"0.5rem"}
                        py={1.5}
                        gap={0}
                        cursor={day?.isDisabled ? "not-allowed" : "pointer"}
                        onClick={() => {
                            !day.isDisabled ? handleSlide(day.date) : null;
                        }}
                    >
                        <Text
                            textStyle={"mediumMd"}
                            color={
                                dayjs(day.date).format(
                                    APPC.APP_HTML_DATE_FORMAT
                                ) ===
                                dayjs(selectedDate).format(
                                    APPC.APP_HTML_DATE_FORMAT
                                )
                                    ? "var(--chakra-colors-white)"
                                    : day.isDisabled
                                      ? "var(--chakra-colors-greyT70)"
                                      : ""
                            }
                        >
                            {dayjs(day.date).format(APPC.APP_DATE_FORMAT)} (
                            {dayjs(day.date).format("ddd").toUpperCase()})
                        </Text>
                    </VStack>
                ))}
            </Flex>
            <Button
                size={"md"}
                className={"btn-icon-md"}
                variant={"transparent"}
                onClick={() => {
                    handleSlide(dayjs(data[6].date).add(1, "days").toDate());
                }}
                isDisabled={dayjs(data[6].date).toDate() >= dayjs(end).toDate()}
            >
                <AppIcon
                    name={"icl-chevron-right-alt"}
                    w="1.5rem"
                    color={"var(--chakra-colors-primary)"}
                />
            </Button>
        </Flex>
    );
};
